import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=63d8cd0c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d8cd0c')) {
      api.createRecord('63d8cd0c', component.options)
    } else {
      api.reload('63d8cd0c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=63d8cd0c&", function () {
      api.rerender('63d8cd0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JjtwS3KZjfzi/JS/comp/childrenage.vue"
export default component.exports